import React from 'react';
import { Marker } from 'react-mapbox-gl';
import styled from 'styled-components';

import { basic } from '../../theme/colors';
import { Dot } from './dot';
import { MapBox } from './maps';

interface Props {
  lon: number;
  lat: number;
  heading?: number;
}

export function PointMap(props: Props) {
  const { lon, lat, heading } = props;
  const center: any = [lon, lat]; // TS gets confused with [number,number] and number[]

  return (
    <MapBox containerStyle={{ width: '100%', height: '100%' }} center={center} zoom={[16]}>
      <Marker coordinates={center} anchor="center">
        <>
          <RippleDot color={basic.haydenBrand} />
          {heading && <Heading heading={heading} />}
        </>
      </Marker>
    </MapBox>
  );
}

const rings = (duration: string, delay: string) => `
  opacity: 0;
  display: block;

  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  content: "";

  border: 0.375em solid rgba(0, 0, 127, 0.2);
  border-radius: 100%;
  animation-name: ripple;
  animation-duration: ${duration};
  animation-delay: ${delay};
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.65, 0, 0.34, 1);
  z-index: 10;
`;

export const RippleDot = styled(Dot as any)`
  position: relative;
  top: 0;

  &::after {
    ${rings('3s', '0s')}
  }

  &::before {
    ${rings('3s', '0.5s')}
  }

  @keyframes ripple {
    from {
      opacity: 1;
      transform: scale3d(1, 1, 1);
    }

    to {
      opacity: 0;
      transform: scale3d(8, 8, 1);
    }
  }
`;

const size = '4px';

export const Heading = styled.div<{ heading: number }>`
  position: absolute;
  top: 00;
  left: 0;
  // outline: 1px solid red;
  // its a 3px Css triangle:
  width: 100%;
  height: 100%;

  transform: rotate(${(props) => props.heading}deg);
  transform-origin: 50% 50%;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, -50%) rotate(-90deg);
    width: 0;
    height: 0;
    border-top: ${size} solid transparent;
    border-bottom: ${size} solid transparent;

    border-left: ${size} solid ${basic.haydenBrand};
  }
`;
